<template>
  <div>
    <div>
      <!-- <el-button
        type="success"
        size="mini"
        icon="el-icon-arrow-left"
        @click="goBack"
        style="background-color: #008a2c; float: left"
        >返回个人中心
      </el-button> -->
      <div @click="goBack" style="cursor: pointer; color: #008a2c">
        <el-button
          type="info"
          style="background-color: #008a2c"
          icon="el-icon-back"
          circle
        ></el-button>
        &nbsp;返回个人中心
      </div>
      <div class="f20 tc">我的课表</div>
    </div>
    <el-divider></el-divider>
   <el-row :gutter="10">
      <el-col :span="22">
        <el-row :gutter="10">
          <el-col :span="4" v-for="(item, index) in semesterList" :key="item.id"
            ><div
              v-if="index < maxSemesterList"
              class="fb grid"
              :class="
                currSemesterId == item.id ? 'bgLightGreen' : 'bgPurpleLight'
              "
              @click="changeSemesterDate(item.id)"
            >
              {{ item.semesterText }}
            </div></el-col
          >
        </el-row>
      </el-col>
      <el-col :span="2">
        <div
          style="line-height: 45px; cursor: pointer; color: #33b615;text-align:right"
          @click="seeMore()"
        >
          <span v-if="seeMoreflg == true"> 收起<i class="el-icon-arrow-up"></i></span>
          <span v-else>更多<i class="el-icon-arrow-down"></i> </span>
        </div>
      </el-col>
    </el-row>
    <el-row style="overflow: hidden">
      <el-col :span="1" style="margin-top:28%">
        <div class="arrowbg" @click="changeWeek('-')">上一周</div>
      </el-col>
      <el-col :span="22">
        <div class="curriculum mt10">
          <div class="mounth">第{{ curWeek + 1 }}周</div>
          <el-row class="th">
            <el-col :span="3">&nbsp;</el-col>
            <el-col :span="3">
              <div>周一</div>
              <div class="grid-text">  
                {{ scheduleList[curWeek]?.dateList2[0].month}}-{{ scheduleList[curWeek]?.dateList2[0].date}}           
                 <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[0],scheduleList[curWeek]?.dateList[1])}}-{{ scheduleList[curWeek]?.dateList[0] }} -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周二</div>
              <div class="grid-text">
                {{ scheduleList[curWeek]?.dateList2[1].month}}-{{ scheduleList[curWeek]?.dateList2[1].date}}
                <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[1],scheduleList[curWeek]?.dateList[2])}}-{{ scheduleList[curWeek]?.dateList[1] }}  -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周三</div>
              <div class="grid-text">
                 {{ scheduleList[curWeek]?.dateList2[2].month}}-{{ scheduleList[curWeek]?.dateList2[2].date}}
                  <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[2],scheduleList[curWeek]?.dateList[3])}}-{{ scheduleList[curWeek]?.dateList[2] }}  -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周四</div>
              <div class="grid-text">
                {{ scheduleList[curWeek]?.dateList2[3].month}}-{{ scheduleList[curWeek]?.dateList2[3].date}}
                  <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[3],scheduleList[curWeek]?.dateList[4])}}-{{ scheduleList[curWeek]?.dateList[3] }}  -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周五</div>
              <div class="grid-text">
                 {{ scheduleList[curWeek]?.dateList2[4].month}}-{{ scheduleList[curWeek]?.dateList2[4].date}}
                <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[4],scheduleList[curWeek]?.dateList[5])}}-{{ scheduleList[curWeek]?.dateList[4] }}  -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周六</div>
              <div class="grid-text">
                 {{ scheduleList[curWeek]?.dateList2[5].month}}-{{ scheduleList[curWeek]?.dateList2[5].date}}
                <!-- {{ scheduleList[curWeek]?.month| monthFormater(scheduleList[curWeek]?.dateList[5],scheduleList[curWeek]?.dateList[6])}}-{{ scheduleList[curWeek]?.dateList[5] }}  -->
              </div>
            </el-col>
            <el-col :span="3">
              <div>周日</div>
              <div class="grid-text">
                 {{ scheduleList[curWeek]?.dateList2[6].month}}-{{ scheduleList[curWeek]?.dateList2[6].date}}
                <!-- {{ scheduleList[curWeek]?.month}}-{{ scheduleList[curWeek]?.dateList[6] }}  -->
              </div>
            </el-col>
          </el-row>
          <el-row
            v-for="item in scheduleList[curWeek]?.curriculumData"
            :index="item.timeId"
            :key="item.timeId"
          >
            <el-col :span="3">
              <div class="fb">第{{ item.timeId }}节</div>
              <div>{{ item.startTime }}</div>
              <div>-</div>
              <div>{{ item.endTime }}</div>
            </el-col>
            <el-col
              v-for="item2 in item.crose"
              :index="item.timeId + item2.weekId"
              :key="item.timeId + item2.weekId"
              :span="3"
              style="padding: 0"
            >
              <!-- <el-dialog
            title="当前课程为"
            v-if="item2.croseID !== undefined"
            v-model="item2.show"  >
          {{item2.croseContent}}
          </el-dialog> -->

              <div
                class="crosebox"
                v-if="!isEmpty(item2.croseDetail[0].croseID)"
                :style="{ backgroundColor: item2.croseDetail[0].bgcolor }"
                @click="showDetail(item2)"
              >
                {{ item2.croseDetail[0].croseContent }}
              </div>
              <div v-else>&nbsp;</div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="1" style="margin-top:28%">
        <div class="arrowbg arright" @click="changeWeek('+')">下一周</div>
      </el-col>
    </el-row>
    <el-dialog
      title="上课地点与节次"
      center
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <span class="fb" style="font-size: 16px">{{ dialogcontent }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >我知道了</el-button
        >
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import { queryYDMHtoken } from "@/api/serviceInfo";
import { getAllSemesters, getSchedule, getStuInfo } from "@/api/schoolCalandar";
export default {
  data() {
    return {
       seeMoreflg: false,
      maxSemesterList: 6,
      maxWeek:17, //最大星期
      dialogVisible: false,
      dialogcontent: "",
      stuInfo: "",
      currSemesterId: "",
        nochangeCurrSemesterId:'',//当前学期-不会改变的
      rescurrWeek:'',   //当前周-不会改变的
      curWeek: 0, //当前星期数-1
      userInfo: "",
      jwtoken: "",
      loadingFlag: false,
      semesterList: "",
      currDateInfo: "",
      scheduleList: [], //整学期各星期日期，课表信息
      curriculumData: [
        {
          timeId: 1, // 时间段id 1为8:20-09:05
          startTime: "8:20",
          endTime: "09:05",
          crose: [],
        },
        {
          timeId: 2, // 时间段id 1为8:20-09:05
          startTime: "9:15",
          endTime: "10:00",
          crose: [],
        },
        {
          timeId: 3, // 时间段id 1为8:20-09:05
          startTime: "10:20",
          endTime: "11:05",
          crose: [],
        },
        {
          timeId: 4, // 时间段id 1为8:20-09:05
          startTime: "11:15",
          endTime: "12:00",
          crose: [],
        },

        {
          timeId: 5, // 时间段id 1为8:20-09:05
          startTime: "12:10",
          endTime: "12:55",
          crose: [],
        },
        {
          timeId: 6, // 时间段id 1为8:20-09:05
          startTime: "13:05",
          endTime: "13:50",
          crose: [],
        },
        {
          timeId: 7, // 时间段id 1为8:20-09:05
          startTime: "14:10",
          endTime: "14:55",
          crose: [],
        },
        {
          timeId: 8, // 时间段id 1为8:20-09:05
          startTime: "15:05",
          endTime: "15:50",
          crose: [],
        },
        {
          timeId: 9, // 时间段id 1为8:20-09:05
          startTime: "16:10",
          endTime: "16:55",
          crose: [],
        },
        {
          timeId: 10, // 时间段id 1为8:20-09:05
          startTime: "17:05",
          endTime: "17:50",
          crose: [],
        },
        {
          timeId: 11, // 时间段id 1为8:20-09:05
          startTime: "18:30",
          endTime: "19:15",
          crose: [],
        },
        {
          timeId: 12, // 时间段id 1为8:20-09:05
          startTime: "19:25",
          endTime: "20:10",
          crose: [],
        },
        //  {
        //   timeId: 13, // 时间段id 1为8:20-09:05
        //   // startTime: "20:20",
        //   // endTime: "21:05",
        //   crose: [],
        // },
      ],
      iconColor: [
        "#3ecdb6",
        "#aa9682",
        "#ff87c3",
        "#37d4ff",
        "#71aace",
        "#71c643",
        "#ff8787",
        "#617f61",
        "#55aa7f",
      ],
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"]),
  },
  mounted() {
    this.getYdmhToken();
    this.userInfo = this.getUserInfo;
  },
  // filters:{
  //   monthFormater(value,curDate,afterDate){
  //     console.log(curDate,afterDate)
  //      console.log(value)
  //     if(curDate>afterDate){
  //       return value-1
  //     }else{
  //       return value
  //     }
  //   }
  // },
  methods: {
       seeMore() {
      this.seeMoreflg = !this.seeMoreflg;

      if (this.seeMoreflg) {
        this.maxSemesterList = this.semesterList.length;
      } else {
        this.maxSemesterList = 6;
      }
    },
    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(() => {
      //     done();
      //   })
      //   .catch(() => {});
    },
    //课程信息详情展示
    showDetail(item) {
      console.log(JSON.stringify(item));
      let content = "";
      if (item.croseDetail.length == 1) {
        if (item.croseDetail[0].classroomName != "") {
          content = content + item.croseDetail[0].classroomName + "\n";
        }
        if (item.croseDetail[0].teacherName != "") {
          content = content + item.croseDetail[0].teacherName + "\n";
        }
        if (item.croseDetail[0].startUnit != "") {
          content =
            content +
            "第" +
            item.croseDetail[0].startUnit +
            "-" +
            item.croseDetail[0].endUnit +
            "节";
        }
        this.dialogcontent = content;
        this.dialogVisible = true;
        //  uni.showModal({
        //      title: item.croseDetail[0].coursesName,
        //      content: content,
        //  showCancel:false,
        //      success: function (res) {

        //      }
        //  });
      } else {
        for (var i = 0; i < item.croseDetail.length; i++) {
          if (item.croseDetail[i].coursesName != "") {
            content = content + item.croseDetail[i].coursesName + "\n";
          }
          if (item.croseDetail[i].classroomName != "") {
            content = content + item.croseDetail[i].classroomName + "\n";
          }
          if (item.croseDetail[i].teacherName != "") {
            content = content + item.croseDetail[i].teacherName + "\n";
          }
          if (item.croseDetail[i].startUnit != "") {
            content =
              content +
              "第" +
              item.croseDetail[i].startUnit +
              "-" +
              item.croseDetail[i].endUnit +
              "节\n";
          }
        }
        this.dialogcontent = content;
        this.dialogVisible = true;
        //  uni.showModal({
        //      title: '课程存在冲突',
        //      content: content,
        //  showCancel:false,
        //      success: function (res) {

        //      }
        //  });
      }
    },
    changeWeek(e) {
      let curWeek;
      if (e == "+") {
        if (this.curWeek < this.maxWeek) {
          curWeek = Number(this.curWeek);
          this.curWeek = curWeek + 1;
        } else {
          this.$message({
            message: "当前为本学期最后一周",
            type: "warning",
          });
          return;
        }
      }
      if (e == "-") {
        if (this.curWeek <= 0) {
          return;
        } else {
          curWeek = Number(this.curWeek);
          this.curWeek = curWeek - 1;
        }
      }
      //  this.getCurrSchedule()
      this.getSchedule(this.currSemesterId);
    },
    changeSemesterDate(currSemesterId) {
       //切换回来，当前学年还是显示当前周
      if(currSemesterId==this.nochangeCurrSemesterId){        
         this.curWeek = this.rescurrWeek * 1 - 1;
        if (this.curWeek > this.maxWeek) {
          this.curWeek=this.maxWeek
        }
      }else{
           this.curWeek = 0;
      }
      this.currSemesterId = currSemesterId;
      this.getSchedule(currSemesterId);
    },
    isEmpty(obj) {    
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    //获取学期列表
    async getSemesterList() {
      const res = await getAllSemesters(this.jwtoken);
      console.log('学期列表',res)
      this.curWeek= res.object.currWeek*1-1
        if (this.curWeek > this.maxWeek) {
          this.curWeek=this.maxWeek
        }
          this.nochangeCurrSemesterId=res.object.currSemesterId;
        this.rescurrWeek=res.object.currWeek
      this.currSemesterId = res.object.currSemesterId;
      this.semesterList = res.object.semesterList;
      this.getSchedule(this.currSemesterId);
    },
    //获取移动门户token
    async getYdmhToken() {
      // const data = await queryYDMHtoken(this.getUserInfo.userid);

      // this.jwtoken = data.data.jwxt;
      this.jwtoken = this.$route.query.jwtoken;
      await this.getStuInfo();
      this.getSemesterList();     
    },
    //获取学生信息
    async getStuInfo() {
      const data = await getStuInfo(this.getUserInfo.userid, this.jwtoken);
      console.log(data);
      this.stuInfo = data.object;
    },
    changeDateList2(data,index){
      console.log(data,index)
      for(let i=0;i<=index;i++){
        data[i].month=data[i].month-1
      }
       return data
    },
    //整学期课表信息获取
    async getSchedule(currSemesterId) {
      const pramas = {
        stdId: this.stuInfo?.id,
        semesterId: currSemesterId,
        weekNum: this.curWeek + 1,
      };
      const data = await getSchedule(pramas, this.jwtoken);
      console.log(data);
      
      if (data.msgCode == "0") {
       /*因为返回的月数据问题，前端来遍历dateList如果日期变小，
        则从当前往前的日期的月份减一(新数据放在dateList2里)*/
       data.data.forEach((item)=>{
        item.dateList2=[]
          item.dateList.forEach((item2,index2)=>{
            item.dateList2.push({
              'month':item.month*1,
              'date':item2
            })
            if(item.dateList[index2+1]){
            if(item2>item.dateList[index2+1]){              
              this.changeDateList2(item.dateList2,index2)              
            }
            }
          })
        })
        console.log(data.data)
        this.scheduleList = data.data;

        //提取当前星期课表数据
        this.getCurrSchedule();
        this.loadingFlag = false;
      }
    },
    //数组分组，用于分配课表课程背景色
    arryGroupMatch(arr) {
      var map = {};
      var dest = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];
        if (!map[ai.no]) {
          dest.push({
            no: ai.no,
            data: [ai],
          });
          map[ai.no] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.no === ai.no) {
              dj.data.push(ai);
              break;
            }
          }
        }
      }
      return dest;
    },
    //每学期课表信息的初始化重新赋值并整合处理
    getCurrSchedule() {
      for (let i = 0; i < this.scheduleList.length; i++) {
        this.scheduleList[i].curriculumData = [];
        let newCurrculum = this.arryGroupMatch(
          this.scheduleList[i].scheduleList
        );
        for (let currculum of this.curriculumData) {
          currculum.crose = [];
          for (let t = 1; t <= 7; t++) {
            let weekday = {
              weekId: t + "",
              croseDetail: [
                {
                  croseContent: "",
                  coursesName: "",
                  courseType: "",
                  classroomName: "",
                  teacherName: "",
                  startUnit: "",
                  endUnit: "",
                  croseID: "",
                  bgcolor: "",
                  show: false,
                },
              ],
            };
            currculum.crose.push(weekday);
          }
        }

        for (let j = 0; j < this.scheduleList[i].scheduleList.length; j++) {
          for (let currculum of this.curriculumData) {
            if (
              currculum.timeId >=
                parseInt(this.scheduleList[i].scheduleList[j].startUnit) &&
              currculum.timeId <=
                parseInt(this.scheduleList[i].scheduleList[j].endUnit)
            ) {
              for (let crose of currculum.crose) {
                if (
                  crose.weekId == this.scheduleList[i].scheduleList[j].weekday
                ) {
                  let detail = {
                    croseContent: "",
                    coursesName: "",
                    courseType: "",
                    classroomName: "",
                    teacherName: "",
                    startUnit: "",
                    endUnit: "",
                    croseID: "",
                    bgcolor: "",
                    show: false,
                  };
                  detail.croseContent =
                    this.scheduleList[i].scheduleList[j].name;
                  detail.coursesName =
                    this.scheduleList[i].scheduleList[j].name;
                  if (
                    this.scheduleList[i].scheduleList[j].classroomName != null
                  ) {
                    detail.croseContent =
                      detail.croseContent +
                      "@" +
                      this.scheduleList[i].scheduleList[j].classroomName;
                    detail.classroomName =
                      this.scheduleList[i].scheduleList[j].classroomName;
                  }
                  if (
                    this.scheduleList[i].scheduleList[j].teacherName != null
                  ) {
                    detail.croseContent =
                      detail.croseContent +
                      "@" +
                      this.scheduleList[i].scheduleList[j].teacherName;
                    detail.teacherName =
                      this.scheduleList[i].scheduleList[j].teacherName;
                  }
                  if (this.scheduleList[i].scheduleList[j].courseType != null) {
                    detail.courseType =
                      this.scheduleList[i].scheduleList[j].courseType;
                  }
                  if (
                    this.scheduleList[i].scheduleList[j].startUnit != null &&
                    this.scheduleList[i].scheduleList[j].endUnit != null
                  ) {
                    detail.startUnit =
                      this.scheduleList[i].scheduleList[j].startUnit;
                    detail.endUnit =
                      this.scheduleList[i].scheduleList[j].endUnit;
                  }
                  detail.croseID = this.scheduleList[i].scheduleList[j].no;
                  for (let m = 0; m < newCurrculum.length; m++) {
                    if (
                      this.scheduleList[i].scheduleList[j].no ==
                      newCurrculum[m].no
                    ) {
                      detail.bgcolor = this.iconColor[m];
                    }
                  }
                  detail.show = false;
                  // console.log("3333333333333"+JSON.stringify(detail))
                  if (crose.croseDetail[0].croseID == "") {
                    crose.croseDetail = [];
                    crose.croseDetail.push(detail);
                  } else {
                    crose.croseDetail.push(detail);
                    crose.croseDetail[0].croseContent =
                      "课程冲突，点击查看详情";
                    crose.croseDetail[0].bgcolor = "black";
                  }
                }
              }
            }
            // this.scheduleList[i].curriculumData.push(this.curriculumData);
          }
        }
        var objDeepCopy = function (source) {
          var sourceCopy = source instanceof Array ? [] : {};
          for (var item in source) {
            sourceCopy[item] =
              typeof source[item] === "object"
                ? objDeepCopy(source[item])
                : source[item];
          }
          return sourceCopy;
        };
        this.scheduleList[i].curriculumData = objDeepCopy(this.curriculumData);
      }
    },
    goBack() {
      this.$router.push("/userCenter");
    },
  },
};
</script>
<style>
.curriculum {
  position: relative;
}
/* position: absolute;left:12px;top:14px; */
.mounth {
  font-weight: bold;
  color: #333;
  z-index: 999;
  width: 12.5%;
  position: absolute;
  left: 0px;
  top: 18px;
  text-align: center;
}
/* 课表 */
.curriculum {
  border-right: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.curriculum .el-col {
  border-left: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  height: 85px;
  text-align: center;
  padding: 10px 0;
}
.curriculum .th .el-col {
  height: 55px;
  background: #f5f6f8;
}
.crosebox {
  height: calc(100% - 20px);
  color: #fff;
  padding-top: 20px;
}
.grid {
  text-align: center;
  padding: 15px 5px;
  margin-bottom: 10px;
  cursor: pointer;
}
.bgPurpleLight {
  background: #e5e9f2;
}
.arrowbg {
  background: url("../../assets/ciclebg.png") no-repeat center;
  background-size: 100% 100%;
  width: 20px;
  height: 50px;
  font-size: 12px;
  padding: 10px 0;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
}
.arright {
  background: url("../../assets/ciclebg_right.png") no-repeat center;
  background-size: 100% 100%;
  margin-left: 20px;
}
</style>